exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p, span {\n  font-size: 11pt; }\n\n.center {\n  width: 98%;\n  margin: 0 auto; }\n\n.w-60 {\n  width: 60%; }\n\n.w-30 {\n  width: 30%; }\n\n.backgrounded {\n  background-color: #eee;\n  font-size: 10pt; }\n\nimg {\n  width: 50px;\n  height: 50px; }\n\n.bg-alert {\n  background-color: #bcbc14; }\n\n.bg-warning {\n  background-color: #ffee4c !important; }\n\n.subTotalAmount {\n  font-weight: normal;\n  font-size: 20px; }\n\n.cut-cable-scissor {\n  font-size: 25px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/product-advisories/product-advisories-details/product-advisories-details.component.scss
// module id = ../../../../../src/app/product-advisories/product-advisories-details/product-advisories-details.component.scss
// module chunks = main